import { buildMakeUseAxios } from "@api";
import type { IAutocompleteAppellation } from "@bbj-types/appellations";
import { useCallback } from "react";

export const axiosAppellation = buildMakeUseAxios(`${import.meta.env.VITE_SETTING_SERVICE_URL}`);

export interface IAppellationAutocompleteParams {
  search: string;
}

export const useGetAppellationsAutocomplete = () => {
  const [state, execute, cancel] = axiosAppellation<IAutocompleteAppellation[]>(
    {
      url: "/v2/romes/appellations/autocomplete",
      method: "get",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (params: IAppellationAutocompleteParams) => {
      return execute({
        params,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
